import { object, string, null as zNull, type infer as zInfer } from "zod/v4";

export const setTeamworkCommerceIntegration = {
  name: "setTeamworkCommerceIntegration" as const,
  input: object({
    baseUrl: string(),
    apiKey: string(),
    greenReturnItemSku: string().optional(),
  }),
  output: zNull(),
};

export type SetTeamworkCommerceIntegrationInput = zInfer<
  typeof setTeamworkCommerceIntegration.input
>;
